const EYE_COLOR = ["Amber", "Blue", "Brown", "Gray", "Green", "Hazel", "Red and violet"];

export default EYE_COLOR;
